import React from 'react';

const Header = () => {
  return (
    <header className="header-gradient shadow-lg">
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-white">
              Xortec Kameramasten Konfigurator
            </h1>
            <p className="text-slate-200 text-sm">
              Mehr als Distribution - Die Experten an Ihrer Seite
            </p>
          </div>
          <div className="hidden md:flex items-center space-x-6 text-slate-200">
            <div className="text-center">
              <div className="text-xs opacity-75 uppercase tracking-wide">Erfahrung</div>
              <div className="font-bold text-lg">18+</div>
              <div className="text-xs">Jahre</div>
            </div>
            <div className="w-px h-12 bg-slate-400 opacity-30"></div>
            <div className="text-center">
              <div className="text-xs opacity-75 uppercase tracking-wide">Material</div>
              <div className="font-bold text-lg">Alu</div>
              <div className="text-xs">Premium</div>
            </div>
            <div className="w-px h-12 bg-slate-400 opacity-30"></div>
            <div className="text-center">
              <div className="text-xs opacity-75 uppercase tracking-wide">Produkte</div>
              <div className="font-bold text-lg">76</div>
              <div className="text-xs">Masten</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;